"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedFulfillmentDeliveryMethodResponseWithCount = exports.mockedFulfillmentDeliveryMethodResponse = exports.mockedFulfillmentDeliveryMethodUpdateRequest = exports.mockedFulfillmentDeliveryMethodCreateRequest = void 0;
const fulfillment_delivery_method_1 = require("../../dto/fulfillment-delivery-method");
const date_util_1 = require("../../utils/date.util");
exports.mockedFulfillmentDeliveryMethodCreateRequest = {
  name: 'DHL',
  costsDetermine: fulfillment_delivery_method_1.CostsDetermineMethod.VOLUME_WEIGHT,
  type: fulfillment_delivery_method_1.DeliveryType.SUPER_EXPRESS,
  daysMin: 3,
  daysMax: 5
};
exports.mockedFulfillmentDeliveryMethodUpdateRequest = {
  type: fulfillment_delivery_method_1.DeliveryType.FAST,
  costsDetermine: fulfillment_delivery_method_1.CostsDetermineMethod.WEIGHT
};
exports.mockedFulfillmentDeliveryMethodResponse = {
  id: 1,
  name: 'DHL',
  costsDetermine: fulfillment_delivery_method_1.CostsDetermineMethod.VOLUME_WEIGHT,
  type: fulfillment_delivery_method_1.DeliveryType.SUPER_EXPRESS,
  daysMin: 3,
  daysMax: 5,
  weightMin: null,
  weightMax: 2000,
  createdAt: date_util_1.takeDaysFromNow(),
  updatedAt: null
};
exports.mockedFulfillmentDeliveryMethodResponseWithCount = {
  items: [exports.mockedFulfillmentDeliveryMethodResponse],
  count: 1
};